/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { color, pxToEm, replacePXinStringWithEM, imageTypes } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED : ANSWER : STYLES --------------- ++++++++++ */
export default {
	answer: {
		
	}
};
